module.exports = __webpack_public_path__ + "static/cristi-ee06dad3192f53b37be8711bf57d47f9.png";